import { CardMedia } from '@mui/material';
import { ROUTES } from 'constants/routes';
import { Offer, CarouselOffers } from 'models';
import { Link } from 'react-router-dom';
import { Footer, Text } from 'components/OfferCard/OfferCard.styles';
import StoreLinkCard from 'assets/images/img-carousel-store-link.jpg';
import {
  StyledOffer,
  StyledOfferCard,
  StyledArrowIcon,
  StyledButton,
  StyledCarousel,
} from './OffersCarousel.styles';

export interface OffersCarouselProps {
  offers: CarouselOffers;
  onViewOffer: (offer: Offer) => void;
}

const OffersCarousel = ({ offers, onViewOffer }: OffersCarouselProps) => (
  <StyledCarousel>
    {offers.map((offer) => (
      <StyledOffer key={offer.id} onClick={() => onViewOffer(offer)} active offer={offer} />
    ))}

    <StyledButton component={Link} to={ROUTES.PERKZ_STORE} disableRipple>
      <StyledOfferCard>
        <CardMedia component="img" image={StoreLinkCard} />
        <Footer>
          <Text variant="h6">Visit the Perkz Store</Text>
          <StyledArrowIcon />
        </Footer>
      </StyledOfferCard>
    </StyledButton>
  </StyledCarousel>
);

export default OffersCarousel;
